// extracted by mini-css-extract-plugin
export var danger = "_3o-6";
export var lightPink = "_3o-a";
export var medium = "_3o-j";
export var nearSquare = "_3o-m";
export var neutralBlue = "_3o-8";
export var neutralYellow = "_3o-7";
export var noCapitalize = "_3o-1";
export var normal = "_3o-2";
export var pill = "_3o-0";
export var primary = "_3o-3";
export var primaryLight = "_3o-4";
export var shadow = "_3o-n";
export var small = "_3o-k";
export var solidBlack = "_3o-i";
export var solidGreen = "_3o-d";
export var solidLightBlue = "_3o-f";
export var solidNavy = "_3o-e";
export var solidOrange = "_3o-h";
export var solidPink = "_3o-g";
export var solidRed = "_3o-b";
export var solidWhite = "_3o-9";
export var solidYellow = "_3o-c";
export var success = "_3o-5";
export var xsmall = "_3o-l";